import { BadgeColors } from "@dotnet/telematics-design-system";

import { SYNC_STATUSES } from "../types/enums";

export const SYNC_STATUS_OPTIONS = {
    [SYNC_STATUSES.Cancelled]: {
        badgeColor: BadgeColors.neutral,
        isBadgeColorInverted: false
    },
    [SYNC_STATUSES.Completed]: {
        badgeColor: BadgeColors.success,
        isBadgeColorInverted: true
    },
    [SYNC_STATUSES.Failed]: {
        badgeColor: BadgeColors.critical,
        isBadgeColorInverted: true
    },
    [SYNC_STATUSES.Syncing]: {
        badgeColor: BadgeColors.success,
        isBadgeColorInverted: false
    }
};
